// Utilities to mirror PHP helpers: video_src() and thumbnail_src()
// Builds CDN URLs based on the current host, handling staging and localhost similarly to PHP.

function resolveBaseDomain() {
  const provided = typeof window !== "undefined" && typeof window.host === "string" ? window.host.trim() : "";
  const raw = provided || (typeof window !== "undefined" ? String(window.location.host || "") : "");
  const host = raw.includes(":") ? raw.split(":")[0] : raw;

  if (window.location.host.includes("localhost") || window.location.host.includes("127.0.0.1")) {
    return "getmytestdomain.com";
  }

  return host;
}

export function videoSrc(videoId) {
  if (/^https?:\/\//i.test(String(videoId || ""))) return String(videoId);

  const baseDomain = resolveBaseDomain();

  const cdnBase = `https://cdn.${baseDomain}`;

  const normalized = String(videoId || "").replace(/^\/+/, "");
  const hasExt = /\.mp4(?:\?.*)?$/i.test(normalized);
  const path = `/${hasExt ? normalized : `${normalized}.mp4`}`;

  return `${cdnBase}${path}`;
}

export function thumbnailSrc(videoId, ext = "webp") {
  const baseDomain = resolveBaseDomain();
  const cdnBase = `https://cdn.${baseDomain}`;
  const cleanExt = String(ext || "webp").replace(/^\./, "");
  const normalized = String(videoId || "").replace(/^\/+/, "");
  return `${cdnBase}/streamsMigration/thumbnails/${normalized}.${cleanExt}`;
}
